import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/location'

function* fetchLocationsRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchLocations'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_LOCATION,
    result,
  })
}

function* fetchLocations({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null // JSON.parse(localStorage.getItem('fetchLocations'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchLocations', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_LOCATION,
    result,
  })
}

function* fetchLocationEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  yield put({
    type: actions.EDIT_LOCATION,
    result,
    openModal
  })
}

function* fetchLocationSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_LOCATION_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_LOCATIONS,
  })
}

function* fetchLocationDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_LOCATION_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_LOCATIONS,
  })
}

function* filterLocations({ searchTerm, noContract }) {
  const result = yield call(list, 1000000, 0, searchTerm, '%20', noContract)
  yield put({
    type: actions.FILTER_LOCATIONS_RECIEVED,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_LOCATIONS, fetchLocations),
    takeEvery(actions.FETCH_LOCATION, fetchLocationEdit),
    takeEvery(actions.SAVE_LOCATION, fetchLocationSave),
    takeEvery(actions.DELETE_LOCATION, fetchLocationDelete),
    takeEvery(actions.RE_FETCH_LOCATIONS, fetchLocationsRefresh),
    takeEvery(actions.FILTER_LOCATIONS, filterLocations),
  ])
}
